import '../elsa-speak-thailand/scss/style.scss';

import 'lite-youtube-embed/src/lite-yt-embed.js'
import '../../partials/assessment/js/assessment';
import bannerLoading from '../elsa-speak-thailand/js/banner';
import lazyCount from '../elsa-speak-thailand/js/components/count';
import lazyAnimated from '../elsa-speak-thailand/js/components/animate';
import collapse from '../faq/js/components/collapse';
import practiceSlider from '../../partials/practice-award/js/practice-english';
import feedbackSlider from '../../partials/feedback/js/feedback';
import { formRegister, countdown } from '../../partials/form-register/js/form';
import dynamicPrice from '../../src/js/utils/dynamic-price';

$(function () {
  bannerLoading();
  collapse();
  practiceSlider();
  feedbackSlider();
  formRegister();
  countdown();
  dynamicPrice();
});

$(window).on('scroll', function () {
  lazyCount();
  lazyAnimated();
});
